module.exports = __webpack_public_path__ + "img/Rectangle 8.247ba53b.png";